import Axios from 'axios';

import { BASE_API_URL } from '../constants';

export const axios = Axios.create({
  baseURL: BASE_API_URL
});
